import { ApplicationProperty } from './applicationproperty';
import { PropertyViewCard } from './property-view-card';

export class Application {
    constructor (
        public RentalApplicationKey: number = 0,
        public PropertyKey: string = '',
        public YardiKey: string = '',
        public PrimaryRentalApplicantKey: number = null,
        public CurrentUserApplicantKey: number = 0,
        public RentalApplicationStatusKey: number = 0,
        public RentalAppStatus: string = '',
        public BrokerReferralId: string = '',
        public Property: ApplicationProperty = new ApplicationProperty(),
        public Campaign: string = '',
        public Source: string = '',
        public AdGroup: string = '',
        public Keyword: string = '',
        public AdCopy: string = '',
        public Device : string = '',
        public Medium : string = '',
        public PropViewCard : PropertyViewCard = new PropertyViewCard(),
        public RentAmount: number = 0,
        public UnitCode: string = '',
    ) { }
}
